import { RegistrationLei } from "./RegistrationLei";

export default RegistrationLei;